// main components
import React from 'react'
import { useTranslation } from 'react-i18next'
// mui components
import {
  makeStyles,
  Typography,
  Card,
  CardContent,
  CardActions,
  Link
} from '@material-ui/core'
import { Configs } from '../../lib/Constants'

const pjson = require('../../../package.json')

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: '8px',
    boxShadow: '6px 9px 43px ' + theme.colors.profile.shadowCard,
    borderBottom: `1px solid ${theme.colors.disabledField}`,
    marginBottom: '2em'
  },
  title: {
    fontSize: '20px',
    margin: '23px 0px 22px 20px',
    fontStyle: 'normal',
    fontWeight: '700',
    lineHeight: '23px',
    color: theme.colors.company.title
  },
  field: {
    fontSize: '16px',
    fontWeight: '400',
    color: theme.colors.settings.fieldInfo,
    marginBottom: '7px'
  },
  actions: {
    padding: '0px 0px'
  }
}))

export const TechSupportCard = props => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <Card className={classes.card} data-testid={'company_contacts_card'}>
      <CardActions disableSpacing classes={{ root: classes.actions }}>
        <Typography classes={{ root: classes.title }}>
          {t('company_settings.tech_support_card.title')}
        </Typography>
      </CardActions>
      <CardContent>
        <Typography classes={{ root: classes.field }}>
          <Link target="_blank" href={Configs.privacyPolicyURL}>
            {t('company_settings.tech_support_card.policy_text')}
          </Link>
          {' & '}
          <Link target="_blank" href={Configs.termsOfServiceURL}>
            {t('company_settings.tech_support_card.conditions_text')}
          </Link>
        </Typography>&nbsp;
        <Typography classes={{ root: classes.field }}>
          {t('company_settings.tech_support_card.version_text') +
            ' ' +
            pjson.version}
        </Typography>
      </CardContent>
    </Card>
  )
}
